import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class ReportService {

  async getResultSmartfrom({ draftId }) {
    try {
      const response = await HttpClient.getBlob(`/api/report/resultsmartfrom?draftId=${draftId}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getResultSmartfromDetail({ draftId }) {
    try {
      const response = await HttpClient.getBlob(`/api/report/resultsmartfromdetail?draftId=${draftId}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getReportDataIndustry(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.industryId && { industryId: body.industryId }),
      });

      const response = await HttpClient.get(`/api/report/industry/data?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getReportExcelIndustry(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.industryId && { industryId: body.industryId }),
      });
      const response = await HttpClient.getBlob(`/api/report/industry/excel?${params}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }





  async getReportDataVisaType(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.smartserviceId && { smartserviceId: body.smartserviceId }),
      });

      const response = await HttpClient.get(`/api/report/visatype/data?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getReportExcelVisaType(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.smartserviceId && { smartserviceId: body.smartserviceId }),
      });
      const response = await HttpClient.getBlob(`/api/report/visatype/excel?${params}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getReportDataKPI(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.empId && { empId: body.empId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });

      const response = await HttpClient.get(`/api/report/kpiindividual/data?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getReportExcelKPI(body) {
    try {

      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body && body.empId && { empId: body.empId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });
      const response = await HttpClient.getBlob(`/api/report/kpiindividual/excel?${params}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new ReportService();



